export default "__VITE_ASSET__aed6a535__"